import "./style.css";

export default function Valores({ valores, editMode, onError, onChange }) {
  const titulo = valores?.title ?? "Nossos Valores";
  const intro = valores?.intro ?? "";
  const sourceItems = editMode
    ? Array.isArray(valores?.items)
      ? valores.items
      : []
    : Array.isArray(valores?.items)
      ? valores.items
      : [];
  const items = sourceItems.map(
    (item) =>
      typeof item === "string"
        ? { letter: item.charAt(0), text: item }
        : { letter: "", text: "", ...item },
  );

  const handleItemChange = (index, value) => {
    const updatedItems = items.map((item, itemIndex) =>
      itemIndex === index
        ? { ...item, letter: value.trim().charAt(0).toUpperCase(), text: value }
        : item,
    );
    onChange("items", updatedItems);
  };

  const handleAddItem = () => {
    onChange("items", [...items, { letter: "", text: "" }]);
  };

  const handleRemoveItem = (index) => {
    onChange(
      "items",
      items.filter((_, itemIndex) => itemIndex !== index),
    );
  };

  if (editMode) {
    return (
      <section className="valores">
        <input
          className="quem-somos-page-h2__input"
          value={titulo || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />
        <textarea style={{ height: "100px" }}
          className="quem-somos-page-p__textarea"
          value={intro || ""}
          onChange={(e) => onChange("intro", e.target.value)}
        />

        <ul className="valores__lista">
          {items.map((item, idx) => (
            <li className="valores__item--editavel" key={idx}>
              <textarea style={{ height: "30px" }}
                className="quem-somos-page-p__textarea"
                value={item?.text || ""}
                onChange={(e) => handleItemChange(idx, e.target.value)}
              />
              <button
                type="button"
                className="valores__remover"
                onClick={() => handleRemoveItem(idx)}
              >
                Remover
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="valores__adicionar"
          onClick={handleAddItem}
        >
          + Adicionar valor
        </button>
      </section>
    );
  }

  return (
    <section className="valores">
      <h2 className="valores__titulo">{titulo}</h2>
      <p className="valores__intro">{intro}</p>

      <ul className="valores__lista">
        {items?.map((item, idx) => (
          <li key={idx}>
            <strong>{item?.text[0]}</strong>
            {item?.text.slice(1)}
          </li>
        ))}
      </ul>
    </section>
  );
}
